import React from 'react'
import styles from './Select.module.css'

export default function Select({ label, name, value, onChange, options, placeholder, theme }) {
  const groupClass = [styles.form__group, styles.field, theme === 'parchment' ? styles.parchment : '']
    .filter(Boolean)
    .join(' ')

  return (
    <div className={groupClass}>
      <select id={name} name={name} className={styles.form__field} value={value || ''} onChange={onChange} required>
        <option value="" disabled>
          {placeholder || `Selecciona ${label.toLowerCase()}`}
        </option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <label htmlFor={name} className={styles.form__label}>
        {label}
      </label>
    </div>
  )
}
